import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { defaultSettings } from "./systemSettingsSchema";

const NOOP_USE_CASE = { execute: async () => ({}) };

class SettingsFormPresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase = NOOP_USE_CASE, upsertUseCase = NOOP_USE_CASE) {
    super(view, getObjectUseCase, upsertUseCase);
  }

  init() {
    this.object = { ...defaultSettings };
    this.change = {};
  }

  getObject() {
    const saved = this.view.getGlobalState?.("systemSettings");
    if (saved && typeof saved === "object") {
      this.object = { ...defaultSettings, ...saved };
    } else {
      this.object = { ...defaultSettings };
    }
    this.view.setObject(this.object);
  }

  async save() {
    this.view.setGlobalState?.({ systemSettings: this.object });
    this.change = {};
  }

  async submit() {
    try {
      this.view.submitting();
      await this.save();
      this.view.submissionSuccess();
      this.view.showSuccess?.("System settings saved successfully.");
    } catch (error) {
      this.view.submissionError?.(error);
      this.view.showError?.(error);
    }
  }
}

export default SettingsFormPresenter;
